import ProgressButton from 'components/ProgressButton';

interface ImageUploadProps {
  label: string;
  Icon?: JSX.Element;
  fullwidth?: boolean;
  accept?: string;
  uploading?: boolean;
  disabled?: boolean;
  onNewImage: (file: File | File[]) => void;
  onFileSizeError?: (oversizedFiles: File[]) => void;
  multiple?: boolean;
  maxFileSizeMB?: number; // e.g., 5 means 5MB
}

const ImageUpload = ({
  label,
  Icon,
  fullwidth,
  accept = 'image/*,.pdf',
  uploading,
  disabled,
  multiple,
  onNewImage,
  onFileSizeError,
  maxFileSizeMB = 5, // default 5MB
}: ImageUploadProps) => {
  const handleFileChange = (fileList: FileList | null) => {
    if (!fileList || fileList.length === 0) return;

    const files = Array.from(fileList);
    const maxSizeBytes = maxFileSizeMB * 1024 * 1024;
    const oversized = files.filter((file) => file.size > maxSizeBytes);

    if (oversized.length > 0) {
      onFileSizeError?.(oversized);
      return;
    }

    if (multiple) {
      onNewImage(files);
    } else {
      onNewImage(files[0]);
    }
  };

  return (
    <ProgressButton
      loading={uploading ?? false}
      variant="contained"
      color="secondary"
      fullWidth={fullwidth}
      size="small"
      startIcon={Icon}
      isLabel
      disabled={disabled}
    >
      {label}
      <input
        id="data-upload"
        name="file"
        type="file"
        accept={accept}
        onChange={(event) => handleFileChange(event.target.files)}
        multiple={multiple}
        hidden
      />
    </ProgressButton>
  );
};

export default ImageUpload;
